import React from "react";
import { inject, observer } from "mobx-react";
import { Checkbox } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";

const CustomerInfo = observer(({ FeedbackStore }) => {
  const key = "customerInfo";
  const { feedback, updateValue, updateIncluded } = FeedbackStore;
  const msgs = useMessageGetter("feedback.form");

  updateIncluded(key, true);

  return (
    <div className="rof-customerInfo">
      <Checkbox
        id={`ROF-${key}`}
        checked={feedback.customerInfo.value}
        onChange={(_e, val) => updateValue(key, val)}
      >
        <div className="rof-checkbox">
          {`${msgs("customerInfo.label")} ${msgs("optional")}`}
        </div>
      </Checkbox>
    </div>
  );
});

export default inject("FeedbackStore")(CustomerInfo);
